export enum Menopause {
    PREMENOPAUSE = 'PRE',
    POSTMENOPAUSE = 'POST',
    PREGNANT = 'PREG'
}